import React, { useEffect } from "react";
import { Table, Card, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeByUserId, hierarchyForSupervisorAndHod } from "../../../core/data/redux/employee/employeeAction";
import { AppDispatch } from "../../../core/data/redux/store";

const TeamHierarchy = () => {
  const dispatch = useDispatch<AppDispatch>();
  const Hierarchy = useSelector((state: any) => state.employee.Hierarchy);
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const employeeId = employeesbyUser?.employeeId;

  useEffect(() => {
    if (!employeesbyUser?.employeeId && user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId }));
    }
  }, [dispatch, employeesbyUser, user]);

  useEffect(() => {
    if (employeeId) {
      dispatch(hierarchyForSupervisorAndHod(employeeId));
    }
  }, [dispatch, employeeId]);

  const supervisorRoot = Hierarchy?.supervisorHierarchy?.[0];
  const hodRoot = Hierarchy?.hodHierarchy?.[0];

  const hasSupervisorChildren =
    supervisorRoot && Array.isArray(supervisorRoot.children) && supervisorRoot.children.length > 0;

  const hasHodChildren = hodRoot && Array.isArray(hodRoot.children) && hodRoot.children.length > 0;

  const normalizeHierarchy = (node: any) => {
    if (!node) return [];

    return [{
      EmployeeID: node.EmployeeID,
      EmployeeName: node.Name,
      Email: node.Email,
      PictureURL: node.PictureURL,
      children: node.children?.map((child: any) => normalizeHierarchy(child)[0]) || []
    }];
  };

  const supervisorData = normalizeHierarchy(supervisorRoot);
  const hodData = normalizeHierarchy(hodRoot);

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      key: "EmployeeName",
      render: (text: string, record: any) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img
            src={record.PictureURL || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
            alt="profile"
            style={{
              width: 35,
              height: 35,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div>
            <div style={{ fontWeight: 600 }}>{text}</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>
              {record.Email}
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Row gutter={16}>
        {hasSupervisorChildren && (
          <Col span={hasSupervisorChildren && hasHodChildren ? 12 : 24}>
            <Card title="Supervisor Hierarchy" bordered={false}>
              <Table
                columns={columns}
                dataSource={supervisorData}
                expandable={{
                  childrenColumnName: "children",
                  defaultExpandAllRows: true,
                }}
                rowKey="EmployeeID"
                pagination={false}
              />
            </Card>
          </Col>
        )}
        {hasHodChildren && (
          <Col span={hasSupervisorChildren && hasHodChildren ? 12 : 24}>
            <Card title="HOD Hierarchy" bordered={false}>
              <Table
                columns={columns}
                dataSource={hodData}
                expandable={{
                  childrenColumnName: "children",
                  defaultExpandAllRows: true,
                }}
                rowKey="EmployeeID"
                pagination={false}
              />
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TeamHierarchy;
